import React, { useEffect, useState } from 'react';
import { Modal, ModalConfirmButton } from '../Modal';
import { INFO_MODAL } from '../../helpers/globalConstants';

/**
 * A popup that only tells the user something.
 *
 * ConfirmModal asks a question and runs a mutation on the answer; this one has
 * nothing to ask and nothing to save. It exists for the things worth a popup
 * rather than a toast -- an outcome the user has to read, which a toast takes
 * away before they have, and which may outlive the dialog that caused it.
 *
 * Mounted once in App, and opened by dispatching `infoModalEvent`.
 */
const initialState = {
  title: 'Please note',
  message: '',
  show: false,
  highlightLabel: '',
  highlightValue: '',
  note: '',
  okLabel: 'OK',
  handleClose: null,
};

export const InfoModal = () => {
  const [state, setState] = useState(initialState);

  const {
    title,
    message,
    show,
    highlightLabel,
    highlightValue,
    note,
    okLabel,
    handleClose,
  } = state;

  const handleEvent = ({ detail }) => {
    setState({ ...initialState, ...(detail || {}), show: true });
  };

  const close = () => {
    setState(initialState);
    if (handleClose) handleClose();
  };

  useEffect(() => {
    document.addEventListener(INFO_MODAL, handleEvent);
    return () => {
      document.removeEventListener(INFO_MODAL, handleEvent);
    };
  }, []);

  if (!show) return <></>;

  return (
    <Modal
      shouldCloseOnClickOutside={true}
      title={title}
      handleClose={close}
      width="sm"
      height="250"
      footerComponent={
        <div className="gap--sm d--flex w--full justify-content--end">
          <ModalConfirmButton cb={close} label={okLabel} variant="primary" />
        </div>
      }
    >
      <div className="w--full d--flex flex--column gap--md">
        {message ? <div className="font--sm">{message}</div> : null}

        {/* The figure the popup is really about, set apart from the sentence
            explaining it so it can be read at a glance. */}
        {highlightValue ? (
          <div className="w--full d--flex align-items--center justify-content--between gap--sm border-full--black-100 radius--md p--md bg--black-50">
            <span className="font--sm font--600 text--secondary">
              {highlightLabel}
            </span>
            <span className="font--md font--600 text--primary">
              {highlightValue}
            </span>
          </div>
        ) : null}

        {note ? (
          <div className="font--xs text--black-600">{note}</div>
        ) : null}
      </div>
    </Modal>
  );
};
